<template lang="pug">
  v-container
    v-form(
      v-model="form")
      v-input.d-none(:error-messages="errorMessages")
      v-row
        v-col(:cols="12")
          input-money(
            v-model="donationToAssociation"
            label="Montant que vous souhaitez donner à l'association"
            filled
            :rules="[value => !!donationToAssociation || `Le montant est requis.`]")
        v-col(:cols="12")
          input-money(
            v-model="donationToYako"
            label="Voulez-vous donner une rétribution à Yako ?"
            filled)
      v-row
        v-col
          v-alert
            template(v-if="errorMessages") {{ errorMessages }}
            template(v-else) Montant total du don :
              strong  {{ $money(donationToAssociation + donationToYako) }}.
</template>

<script>
import { page } from '@iez/core'
import InputMoney from '@iez/components/inputs/money/'
import { ref, computed } from '@vue/composition-api'
import createOnClick from '@iez/lib/create-on-click/'
import { routeCurrent, default as router } from '@iez/core/router/'
import { injectRouteState } from '@iez/core'

const route = {
  path: `/donate-to-assocation/:associationId`,
  name: `DonateToAssociation`
}

export default {
  ...route,

  components: {
    InputMoney
  },

  setup () {
    const routeState = injectRouteState()
    routeState.associationId = routeCurrent.params.associationId

    const form = ref(false)
    const donationToAssociation = ref(0)
    const donationToYako = ref(0)

    const errorMessages = computed(
      () =>  donationToAssociation.value + donationToYako.value < 300
        ? `Le montant total doit être supérieur à 3€.`
        : null
    )

    page.topBar.set({
      title: `Faire un don à une association`
    })

    const submit = () => {
      routeState.amount = donationToYako.value + donationToAssociation.value
      router.push({
        name: `DonateToAssociationPayment`
      })
    }

    page.bottomAction.set(
      () => form.value
        ? {
          action: {
            label: `Payer`,
            onClick: createOnClick({
              submit
            })
          }
        } : null
    )

    return {
      form,
      donationToAssociation,
      donationToYako,
      errorMessages
    }
  }
}
</script>
